<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="ContractServices"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <VueSlickgrid
    name="contractServices"
    :headerTitle="'Contract services'|pgettext('ContractServices')"
    :items="ds"
    checkbox-row-selection
    export-to-csv
    :exportToCsvFilename="'contract-services'|pgettext('filename')"
    :columnDefaults="b_2248226175642056_columnDefaults"
    :columns="b_2248226175642056_columns"
    class="page--grid"
    ref="grid"
    @selectedRowsChanged="evh_2248226175642056_selectedRowsChanged($event, {})"
    @command="evh_2248226175642056_command($event, {})"
  >
    <DIV
      class="flex-grow-1 d-flex"
      slot="toolbar"
    >
      <DIV
        class="mx-2"
      >
        <ItpFormCheckbox
          name="skip_archived"
          :label="'Skip archived contracts'|pgettext('Contracts')"
          inline
          v-model="dsParams.skip_archived"
        >
        </ItpFormCheckbox>
      </DIV>
      <DIV
        class="border-left px-4"
      >
        <ItpButton
          :disabled="!selectedItems || !selectedItems.length"
          :icon="$config.contract.createContractIcon"
          :text="'Bulk edit...'|pgettext('ContractServices')"
          size="sm"
          variant="light"
          @click="evh_4440454779651433_click($event, {})"
        >
        </ItpButton>
      </DIV>
      <PageHelp
        path="/contracts/contracts.html"
      >
      </PageHelp>
    </DIV>
  </VueSlickgrid>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

addRoute(
  {
    name: "contractServices",
    path: "/contract-services",
    component: "ContractServices"
  }
)

@Component()
export default class ContractServices extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
    this.$$cache_dsParams = new ComponentValueCache(this, "dsParams", "ContractServices.dsParams");
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  selectedItems!: any;
  dsParams!: any;
  ds!: any;

  async $$load_ds() {
    return this.$fn.slickDataSource('integro_api/list_contract_service', {
      parameters: () => ({ ...this.dsParams, date: this.$fn.today() })
    })
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_2248226175642056_columnDefaults!: any;
  b_2248226175642056_columns!: any;
  dataMembers = ['selectedItems', 'dsParams', 'ds', 'ux', 'b_7315092382398562_modalBindings', 'b_2248226175642056_columnDefaults', 'b_2248226175642056_columns'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        selectedItems: [
        ]
        ,
        dsParams: {
          skip_archived: true,
        }
        ,
        ds: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
        b_2248226175642056_columnDefaults: {
          sortable: true,
          filterable: true,
          resizable: true,
          selectable: true,
        }
        ,
        b_2248226175642056_columns: [{
          field: "contract_revision",
          name: this.$fn.pgettext("Contract", "Contract number"),
          params: {
            sortPath: "contract_revision.contract_number",
          }
          ,
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "getvalue",
              opts: {
                field: "contract_revision.contract_number",
                source: "row",
              }
              ,
            }
              ,
            {
              name: "routeLink",
              to: "contract",
              navigateOnIconClick: true,
              skipExport: true,
              params: {
                id: "contract_id",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          id: "contract_type",
          field: "contract_revision",
          name: this.$fn.pgettext("Contracts", "Type"),
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "getvalue",
              opts: {
                field: "contract_type",
                source: "value",
              }
              ,
            }
              ,
            {
              name: "gettext",
              context: "ContractTypes",
              conversion: "StartCase",
              filterInput: true,
            }
              ,
            {
              name: "badge",
              variantMapSource: "inputValue",
              variantmap: {
                rental: "contract-type--rental",
                vendor: "contract-type--vendor",
                rental_agreement: "contract-type--rental_agreement",
                service: "contract-type--service",
                parking: "contract-type--parking",
                unknown: "contract-type--unknown",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          id: "contract_status",
          field: "contract_revision",
          name: this.$fn.pgettext("Contracts", "Status"),
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "getvalue",
              opts: {
                field: "status",
                source: "value",
              }
              ,
            }
              ,
            {
              name: "gettext",
              context: "ContractStatus",
              conversion: "StartCase",
              filterInput: true,
            }
              ,
            {
              name: "badge",
              variantMapSource: "fieldValue",
              variantmap: {
                draft: "light",
                approved: "success",
                signed: "success",
                active: "primary",
                ended: "warning",
                terminated: "warning",
                rescinded: "danger",
                archived: "light",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "rental",
          name: this.$fn.pgettext("ContractServices", "Rental"),
          type: "command",
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "template",
              engine: "hb",
              format: "<span>\n\
  {{~#if $value }}\n\
    <strong>{{ $value.name }}</strong>\n\
    {{~#if $value.house_number }} | {{ $value.house_number }}{{/if }}\n\
    {{~#if $value.area }} ({{$value.area}}{{$value.unit_of_area}}){{/if }}\n\
  {{~/if }}\n\
</span>\n\
",
            }
              ,
            {
              name: "routeLink",
              to: "rental",
              navigateOnIconClick: true,
              params: {
                id: "rental_id",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "company",
          name: this.$fn.pgettext("Contract", "Company"),
          params: {
            sortPath: "company.name",
          }
          ,
          type: "command",
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "template",
              engine: "hb",
              format: "<span>\n\
  {{~#if $value }}\n\
    <strong title=\"{{ $value.name }}\">{{ $value.code }}</strong>\n\
  {{~/if }}\n\
</span>\n\
",
            }
              ,
            {
              name: "routeLink",
              to: "company",
              navigateOnIconClick: true,
              params: {
                id: "company.id",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "counterparty",
          name: this.$fn.pgettext("Contract", "Counterparty"),
          params: {
            sortPath: "counterparty.name",
          }
          ,
          type: "command",
          formatter: {
            name: "chain",
            mode: "mapReduce",
            formatters: [{
              name: "template",
              engine: "hb",
              format: "<span>\n\
  {{~#if $value }}\n\
    <strong title=\"{{ $value.name }}\">{{ $value.code }}</strong>\n\
  {{~/if }}\n\
</span>\n\
",
            }
              ,
            {
              name: "routeLink",
              to: "company",
              navigateOnIconClick: true,
              params: {
                id: "counterparty.id",
              }
              ,
            }
              ,
            ]
            ,
          }
          ,
        }
          ,
        {
          field: "valid_from",
          name: this.$fn.pgettext("Contracts", "Valid From"),
          formatter: {
            name: "date",
          }
          ,
        }
          ,
        {
          field: "valid_to",
          name: this.$fn.pgettext("Contracts", "Valid To"),
          formatter: {
            name: "date",
          }
          ,
        }
          ,
        {
          field: "next_billing_due_date",
          name: this.$fn.pgettext("Contracts", "Next Bill"),
          formatter: {
            name: "date",
          }
          ,
        }
          ,
        {
          field: "next_indexation_date",
          name: this.$fn.pgettext("Contracts", "Next Indexation Date"),
          formatter: {
            name: "date",
          }
          ,
        }
          ,
        {
          field: "name",
          name: this.$fn.pgettext("ContractService", "Name"),
          type: "command",
        }
          ,
        {
          field: "invoice_notes",
          name: this.$fn.pgettext("ContractService", "Invoice notes"),
        }
          ,
        {
          field: "billing_category",
          name: this.$fn.pgettext("ContractService", "Billing category"),
        }
          ,
        {
          field: "invoice_group_id",
          name: this.$fn.pgettext("ContractService", "Invoice group"),
        }
          ,
        {
          field: "description",
          name: this.$fn.pgettext("ContractService", "Description"),
        }
          ,
        {
          field: "intermediated_service",
          name: this.$fn.pgettext("ContractService", "Intermediated service"),
          formatter: "checkbox",
        }
          ,
        {
          field: "billing_frequency",
          name: this.$fn.pgettext("ContractService", "Billing frequency"),
        }
          ,
        {
          field: "billing_currency",
          name: this.$fn.pgettext("ContractService", "Billing currency"),
        }
          ,
        {
          field: "billing_date_rule",
          name: this.$fn.pgettext("ContractService", "Billing date"),
          formatter: {
            name: "template",
            engine: "hb",
            format: "<span>\n\
  {{~#if $value }}\n\
    {{~#if $value.description }}\n\
      {{ $value.description }}\n\
    {{ else }}\n\
      {{~#if $value.anchor }}{{ $value.anchor }}{{/if }}\n\
      {{~#if $value.offset_days }}\n\
        {{ $value.offset_days }}\n\
      {{/if }}\n\
    {{~/if }}\n\
  {{~/if }}\n\
</span>\n\
",
          }
          ,
        }
          ,
        {
          field: "due_date_rule",
          name: this.$fn.pgettext("ContractService", "Due date"),
          formatter: {
            name: "template",
            engine: "hb",
            format: "<span>\n\
  {{~#if $value }}\n\
    {{~#if $value.description }}\n\
      {{ $value.description }}\n\
    {{ else }}\n\
      {{~#if $value.anchor }}{{ $value.anchor }}{{/if }}\n\
      {{~#if $value.offset_days }}\n\
        {{ $value.offset_days }}\n\
      {{/if }}\n\
    {{~/if }}\n\
  {{~/if }}\n\
</span>\n\
",
          }
          ,
        }
          ,
        {
          field: "exchange_rate_date_rule",
          name: this.$fn.pgettext("ContractService", "Exchange rate date"),
          formatter: {
            name: "template",
            engine: "hb",
            format: "<span>\n\
  {{~#if $value }}\n\
    {{~#if $value.anchor }}{{ $value.anchor }}{{/if }}\n\
    \n\
    {{~#if $value.description }}{{ $value.description }}{{~/if }}\n\
  {{~/if }}\n\
</span>\n\
",
          }
          ,
        }
          ,
        {
          field: "created_at",
          name: this.$fn.pgettext("BrowserColumn", "Create time"),
          formatter: "datetime",
        }
          ,
        ]
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.$fn.gettext("Contract services"),
        icon: this.$config.contract.icon,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_7040_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_7040, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_setData_7042_getActionArgs($event: actions.ActionEvent): Promise<actions.SetDataActionArgs> {
    // parameterResolver name=act_2248226175642056_setData_7042, alias=undefined
    return {
      path: "selectedItems",
      value: this.$refs.grid.getSelectedItems(),
      resolve: false,
      noTouchLastLoaded: false,
      noTakeSnapshot: false,
    }
  }

  async evh_2248226175642056_selectedRowsChanged(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_selectedRowsChanged.executeFromDOM(this, event, scope);
  }

  async act_2248226175642056_showModal_7044_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_2248226175642056_showModal_7044, alias=undefined
    return {
      name: "ContractService",
      props: {
        modal: true,
        oid: $event.data.data.id,
      }
      ,
    }
  }

  async evh_2248226175642056_command_7043_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_2248226175642056_command_7043, alias=undefined
    return $event.data.column.id === 'name'
  }

  async evh_2248226175642056_command(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_command.executeFromDOM(this, event, scope);
  }

  async act_4440454779651433_reloadSlickgrid_7048_getActionArgs($event: actions.ActionEvent): Promise<actions.ReloadSlickgridActionArgs> {
    // parameterResolver name=act_4440454779651433_reloadSlickgrid_7048, alias=undefined
    return {
      grid: "contractServices",
    }
  }

  async evh_4440454779651433_close_7047_getWhen($event: actions.ActionEvent): Promise<actions.EventHandlerImplArgs> {
    // parameterResolver name=evh_4440454779651433_close_7047, alias=undefined
    return $event.data.modalResult.ok
  }

  async act_4440454779651433_showModal_7046_getActionArgs($event: actions.ActionEvent): Promise<actions.ShowModalActionArgs> {
    // parameterResolver name=act_4440454779651433_showModal_7046, alias=undefined
    return {
      name: "BulkContractServiceEditor",
      props: {
        items: this.selectedItems,
      }
      ,
    }
  }

  async evh_4440454779651433_click(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_4440454779651433_click.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_7040: actions.CloseModalAction;
    evh_7315092382398562_close_7039: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_setData_7042: actions.SetDataAction;
    evh_2248226175642056_selectedRowsChanged_7041: actions.EventHandlerImpl;
    evh_2248226175642056_selectedRowsChanged: actions.EventHandlerGroup;
    act_2248226175642056_showModal_7044: actions.ShowModalAction;
    evh_2248226175642056_command_7043: actions.EventHandlerImpl;
    evh_2248226175642056_command: actions.EventHandlerGroup;
    act_4440454779651433_reloadSlickgrid_7048: actions.ReloadSlickgridAction;
    evh_4440454779651433_close_7047: actions.EventHandlerImpl;
    act_4440454779651433_showModal_7046: actions.ShowModalAction;
    evh_4440454779651433_click_7045: actions.EventHandlerImpl;
    evh_4440454779651433_click: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_7040 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_7040_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_7039 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_7040,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_7039],
      }
    );
    const act_2248226175642056_setData_7042 = new actions.SetDataAction(
      {
        actionArgs: this.act_2248226175642056_setData_7042_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_selectedRowsChanged_7041 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_setData_7042,
        event: "selectedRowsChanged",
        displayName: "setData",
      }
    );
    const evh_2248226175642056_selectedRowsChanged = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_selectedRowsChanged_7041],
      }
    );
    const act_2248226175642056_showModal_7044 = new actions.ShowModalAction(
      {
        actionArgs: this.act_2248226175642056_showModal_7044_getActionArgs,
        events: [],
      }
    );
    const evh_2248226175642056_command_7043 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_showModal_7044,
        event: "command",
        when: this.evh_2248226175642056_command_7043_getWhen,
        displayName: "showModal",
      }
    );
    const evh_2248226175642056_command = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_command_7043],
      }
    );
    const act_4440454779651433_reloadSlickgrid_7048 = new actions.ReloadSlickgridAction(
      {
        actionArgs: this.act_4440454779651433_reloadSlickgrid_7048_getActionArgs,
        events: [],
      }
    );
    const evh_4440454779651433_close_7047 = new actions.EventHandlerImpl(
      {
        action: act_4440454779651433_reloadSlickgrid_7048,
        event: "close",
        when: this.evh_4440454779651433_close_7047_getWhen,
        displayName: "reloadSlickgrid",
      }
    );
    const act_4440454779651433_showModal_7046 = new actions.ShowModalAction(
      {
        actionArgs: this.act_4440454779651433_showModal_7046_getActionArgs,
        events: [evh_4440454779651433_close_7047],
      }
    );
    const evh_4440454779651433_click_7045 = new actions.EventHandlerImpl(
      {
        action: act_4440454779651433_showModal_7046,
        event: "click",
        displayName: "showModal",
      }
    );
    const evh_4440454779651433_click = new actions.EventHandlerGroup(
      {
        handlers: [evh_4440454779651433_click_7045],
      }
    );
    return {
      act_7315092382398562_closeModal_7040,
      evh_7315092382398562_close_7039,
      evh_7315092382398562_close,
      act_2248226175642056_setData_7042,
      evh_2248226175642056_selectedRowsChanged_7041,
      evh_2248226175642056_selectedRowsChanged,
      act_2248226175642056_showModal_7044,
      evh_2248226175642056_command_7043,
      evh_2248226175642056_command,
      act_4440454779651433_reloadSlickgrid_7048,
      evh_4440454779651433_close_7047,
      act_4440454779651433_showModal_7046,
      evh_4440454779651433_click_7045,
      evh_4440454779651433_click,
    }
  }
}

Vue.component("ContractServices", ContractServices);

</script>